import { render, staticRenderFns } from "./IconView.vue?vue&type=template&id=5e54ed6a&scoped=true"
import script from "./IconView.vue?vue&type=script&lang=js"
export * from "./IconView.vue?vue&type=script&lang=js"
import style0 from "./IconView.vue?vue&type=style&index=0&id=5e54ed6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e54ed6a",
  null
  
)

export default component.exports